import {computed} from 'vue';
import {useLocale, useAuth} from '#imports';
import {useFeatureFlag, type FeatureFlagId} from '@malt/feature-flags';

const NEW_UNLOGGED_NAVBAR_FLAG: FeatureFlagId = 'new-unlogged-navbar';
const NEW_UNLOGGED_NAVBAR_MALT_COM_FLAG: FeatureFlagId = 'new-unlogged-navbar-malt-com';
const NAVBAR_TRANSPARENT_MODE_FLAG: FeatureFlagId = 'navbar-transparent-mode';
const NAVBAR_TRANSPARENT_MODE_MALT_COM_FLAG: FeatureFlagId = 'navbar-transparent-mode-malt-com';

function useHostScopedFeatureFlag(localeFlag: FeatureFlagId, maltComFlag: FeatureFlagId) {
    const {isMultiLocaleHost} = useLocale();
    const localeEnabled = useFeatureFlag(localeFlag);
    const maltComEnabled = useFeatureFlag(maltComFlag);

    return computed(() => (isMultiLocaleHost.value ? maltComEnabled.value : localeEnabled.value));
}

export function useNewUnloggedNavbar() {
    const {loggedIn} = useAuth();
    const showNewUnloggedNavbar = computed<boolean>(
        () => !loggedIn && useHostScopedFeatureFlag(NEW_UNLOGGED_NAVBAR_FLAG, NEW_UNLOGGED_NAVBAR_MALT_COM_FLAG).value,
    );
    return {
        showNewUnloggedNavbar,
    };
}

export function useNavbarTransparentMode() {
    return useHostScopedFeatureFlag(NAVBAR_TRANSPARENT_MODE_FLAG, NAVBAR_TRANSPARENT_MODE_MALT_COM_FLAG);
}
